import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
import { IntlProvider } from 'react-intl';
import AppLocale from '../../../shared/localization';
import {
  useLocaleActionsContext,
  useLocaleContext,
} from '../AppContextProvider/LocaleContextProvide';
import { IntlGlobalProvider } from '../helper/Utils';
import { useCookies } from 'react-cookie';
import { Default_Language } from '../../../shared/constants/AppConst';
import MainUtils from '../../../shared/utils/main';
import { useLayoutActionsContext } from '../AppContextProvider/LayoutContextProvider';
import { ThemeDirection } from '../../../shared/constants/AppEnums';

const AppLocaleProvider = (props: any) => {
  const { rtlLocale, locale }: any = useLocaleContext();
  const currentAppLocale: any = AppLocale[locale?.code];
  const [cookies] = useCookies([Default_Language]);
  const { updateLocale }: any = useLocaleActionsContext();
  const { updateDirection }: any = useLayoutActionsContext();

  useEffect(() => {
    if (!MainUtils.isEmptyValue(cookies[Default_Language])) {
      const selectedLocale = cookies[Default_Language];
      if (rtlLocale.indexOf(selectedLocale) !== -1) {
        updateDirection(ThemeDirection.RTL);
      } else {
        updateDirection(ThemeDirection.LTR);
      }
      updateLocale({ code: selectedLocale });
    }
  }, [cookies, rtlLocale]);

  return (
    <IntlProvider
      locale={currentAppLocale.locale}
      messages={currentAppLocale.messages}>
      <IntlGlobalProvider>{props.children}</IntlGlobalProvider>
    </IntlProvider>
  );
};

export default AppLocaleProvider;

AppLocaleProvider.propTypes = {
  children: PropTypes.node.isRequired,
};
